import React, { useState } from "react";

export default function SplitScreenSelector({ id, screen1Label, screen1Ref, screen2Label, screen2Ref, displayFlag }) {

  const [hover, setHover] = useState(null);

  const thisContainer = {
    display: displayFlag,
    position: "fixed",
    top: "10px",
    left: "calc(50% - 250px)",
    zIndex: "20000",
    flexDirection: "column"
  };

  const primaryContainer = {
    display: "flex",
    width: "600px",
    height: "40px",
    background: "linear-gradient(180deg, #F4F7FA 0%, #DADFE6 100%)",
    borderRadius: "20px",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 3px 6px rgba(0,0,0,0.15)",
  };

  const baseLabel = {
    display: "flex",
    width: "33%",
    height: "100%",
    alignItems: "center",
    justifyContent: "space-around",
    color: "black",
    fontSize: "14px",
    cursor: "pointer",
    borderRight: "1px solid rgba(255,255,255,0.2)",
    transition: "all 0.25s ease",
  };

  const glowStyle = {
    boxShadow: "0 0 12px rgba(77,168,255,0.75), inset 0 0 6px rgba(255,255,255,0.5)",
    background: "rgba(255,255,255,0.08)",
    borderRadius: "20px",
  };

  const splitLabel = {
    ...baseLabel,
    borderRight: "none"
  };

  const goSplitLeft = () => {
    screen1Ref.current.style.width = "100%";
    screen2Ref.current.style.width = "0%";
  };

  const goSplitRight = () => {
    screen1Ref.current.style.width = "0%";
    screen2Ref.current.style.width = "100%";
  };

  const goSplit50 = () => {
    screen1Ref.current.style.width = "50%";
    screen2Ref.current.style.width = "50%";
  };

  return (
    <div style={thisContainer}>
      <div style={primaryContainer}>

        {/* LEFT */}
        <div
          style={{ ...baseLabel, ...(hover === "left" ? glowStyle : {}) }}
          onMouseEnter={() => setHover("left")}
          onMouseLeave={() => setHover(null)}
          onClick={goSplitLeft}
        >
         New Project
        </div>

        {/* RIGHT */}
        <div
          style={{ ...baseLabel, ...(hover === "right" ? glowStyle : {}) }}
          onMouseEnter={() => setHover("right")}
          onMouseLeave={() => setHover(null)}
          onClick={goSplitRight}
        >
          View App
        </div>
		{/* RIGHT */}
       <div
         style={{ ...baseLabel, ...(hover === "right1" ? glowStyle : {}) }}
         onMouseEnter={() => setHover("right1")}
         onMouseLeave={() => setHover(null)}
         onClick={goSplitRight}
       >
         Dashboard
       </div>

        {/* SPLIT */}
        <div
          style={{ ...splitLabel, ...(hover === "split" ? glowStyle : {}) }}
          onMouseEnter={() => setHover("split")}
          onMouseLeave={() => setHover(null)}
          onClick={goSplit50}
        >
          Schedule (Gantt)
        </div>

      </div>
    </div>
  );
}
